import { useEffect, useState } from "react";

import { EventBusTopic } from "@moodys/mdc-frontend.utils.event-bus";

import { useEventBus } from "hooks/useEventBus";

export const ANONYMOUS_DEFAULT = "Anonymous";

export const useUserInfo = () => {
  const [isAuthenticated] = useEventBus(EventBusTopic.IsAuthenticated);
  const [userDetails] = useEventBus(EventBusTopic.UserDetails);
  const [userEmail, setUserEmail] = useState(userDetails?.email);
  const [userId, setUserId] = useState(userDetails?.mdcUserId);

  useEffect(() => {
    if ((isAuthenticated || isAuthenticated === false) && !!userDetails) {
      const email =
        userDetails.email === ANONYMOUS_DEFAULT
          ? userDetails.email
          : userDetails.email?.toLowerCase();
      setUserEmail(email || ANONYMOUS_DEFAULT);
      setUserId(userDetails.mdcUserId);
    }
  }, [isAuthenticated, userDetails]);

  return { userEmail, userId, isAuthenticated };
};
